import { ColumnDef } from "@tanstack/react-table";

export type WallexRate = {
  id: string;
  currency: string;
  buyingRate: number | "loading" | null;
  sellingRate: number | "loading" | null;
};

export const wallexRateColumns: ColumnDef<WallexRate>[] = [
  {
    accessorKey: "currency",
    header: () => <div className="font-medium">CURRENCY PAIR</div>,
    cell: ({ row }) => (
      <div className="text-left">{row.getValue("currency")}</div>
    ),
  },
  {
    accessorKey: "buyingRate",
    header: () => <div className="text-center font-medium">CUSTOMER BUY RATE</div>,
    cell: ({ row }) => {
      const value = row.getValue("buyingRate") as number | "loading" | null;
      if (value === "loading" || value === null) {
        return (
          <div className="text-center">
            <span className="text-muted-foreground">loading</span>
          </div>
        );
      }
      return (
        <div className="text-center">
          {typeof value === "number" ? Number(value).toLocaleString() : String(value)}
        </div>
      );
    },
  },
  {
    accessorKey: "sellingRate",
    header: () => <div className="text-center font-medium">CUSTOMER SELL RATE</div>,
    cell: ({ row }) => {
      const value = row.getValue("sellingRate") as number | "loading" | null;
      if (value === "loading" || value === null) {
        return (
          <div className="text-center">
            <span className="text-muted-foreground">loading</span>
          </div>
        );
      }
      return (
        <div className="text-center">
          {typeof value === "number" ? Number(value).toLocaleString() : String(value)}
        </div>
      );
    },
  },
];
